import { createFileRoute } from '@tanstack/react-router';
import { FiscalPage } from '@/features/admin';

export const Route = createFileRoute('/_auth/o/$orgId/admin/fiscal')({
  component: FiscalPage,
});
